<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="settlementTypeId">
    <th class="header" mat-header-cell *matHeaderCellDef>Tipo de Liquidação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.settlementTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationTypeId">
    <th class="header" mat-header-cell *matHeaderCellDef>Tipo de Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioDocument">
    <th class="header" mat-header-cell *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th class="header" mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBank">
    <th class="header" mat-header-cell *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBranch">
    <th class="header" mat-header-cell *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioAccount">
    <th class="header" mat-header-cell *matHeaderCellDef>Conta Corrente</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioCetipAccount">
    <th class="header" mat-header-cell *matHeaderCellDef>Conta CETIP</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioCetipAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th class="header" mat-header-cell *matHeaderCellDef>Quantidade</th>
    <td mat-cell *matCellDef="let element">
      {{ element.amount | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="unitPrice">
    <th class="header" mat-header-cell *matHeaderCellDef>Preço Unitário</th>
    <td mat-cell *matCellDef="let element">
      {{ element.unitPrice | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="IsSecondaryMarket">
    <th class="header" mat-header-cell *matHeaderCellDef>
      Mercado secundário?
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.isSecondaryMarket ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationValue">
    <th class="header" mat-header-cell *matHeaderCellDef>Valor da Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationValue | currency: "R$":"symbol":"1.2-2" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="assetType">
    <th class="header" mat-header-cell *matHeaderCellDef>Tipo de Ativo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.assetType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="assetCode">
    <th class="header" mat-header-cell *matHeaderCellDef>Código Ativo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.assetCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="expirationDate">
    <th class="header" mat-header-cell *matHeaderCellDef>Data Vencimento</th>
    <td mat-cell *matCellDef="let element">
      {{ element.expirationDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="issueFee">
    <th class="header" mat-header-cell *matHeaderCellDef>Taxa de Emissão</th>
    <td mat-cell *matCellDef="let element">
      {{ element.issueFee }}
    </td>
  </ng-container>

  <ng-container matColumnDef="issueDate">
    <th class="header" mat-header-cell *matHeaderCellDef>Data de Emissão</th>
    <td mat-cell *matCellDef="let element">
      {{ element.issueDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="issuer">
    <th class="header" mat-header-cell *matHeaderCellDef>Emissor</th>
    <td mat-cell *matCellDef="let element">
      {{ element.issuer }}
    </td>
  </ng-container>

  <ng-container matColumnDef="index">
    <th class="header" mat-header-cell *matHeaderCellDef>Indexador</th>
    <td mat-cell *matCellDef="let element">
      {{ element.index }}
    </td>
  </ng-container>

  <ng-container matColumnDef="indexPercent">
    <th class="header" mat-header-cell *matHeaderCellDef>
      Percentual do Indexador
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.indexPercent }}
    </td>
  </ng-container>

  <ng-container matColumnDef="indexBase">
    <th class="header" mat-header-cell *matHeaderCellDef>Base Indexador</th>
    <td mat-cell *matCellDef="let element">
      {{ element.indexBase }}
    </td>
  </ng-container>

  <ng-container matColumnDef="interestType">
    <th class="header" mat-header-cell *matHeaderCellDef>Tipo de Juros</th>
    <td mat-cell *matCellDef="let element">
      {{ element.interestType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="settlementDate">
    <th class="header" mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.settlementDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="acquisitionDate">
    <th class="header" mat-header-cell *matHeaderCellDef>Data de Aquisição</th>
    <td mat-cell *matCellDef="let element">
      {{ element.acquisitionDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="subscriptionDate">
    <th class="header" mat-header-cell *matHeaderCellDef>Data de Subscrição</th>
    <td mat-cell *matCellDef="let element">
      {{ element.subscriptionDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationCode">
    <th class="header" mat-header-cell *matHeaderCellDef>Código Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isCetipVoice">
    <th class="header" mat-header-cell *matHeaderCellDef>CETIP Voice</th>
    <td mat-cell *matCellDef="let element">
      {{ element.isCetipVoice ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="voiceNumber">
    <th class="header" mat-header-cell *matHeaderCellDef>Número CETIP</th>
    <td mat-cell *matCellDef="let element">
      {{ element.voiceNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="propositionNumber">
    <th class="header" mat-header-cell *matHeaderCellDef>Número Proposta</th>
    <td mat-cell *matCellDef="let element">
      {{ element.propositionNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isNewCounterpart">
    <th class="header" mat-header-cell *matHeaderCellDef>
      É Nova Contraparte?
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.isNewCounterpart ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartName">
    <th class="header" mat-header-cell *matHeaderCellDef>Nome Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartType">
    <th class="header" mat-header-cell *matHeaderCellDef>Tipo Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartDocument">
    <th class="header" mat-header-cell *matHeaderCellDef>
      CPF/CNPJ Contraparte
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartBank">
    <th class="header" mat-header-cell *matHeaderCellDef>Banco Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartBranch">
    <th class="header" mat-header-cell *matHeaderCellDef>
      Agência Contraparte
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpartAccount">
    <th class="header" mat-header-cell *matHeaderCellDef>Conta Contraparte</th>
    <td mat-cell *matCellDef="let element">
      {{ element.counterpartAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th class="header" mat-header-cell *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>
  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="ColumnsPrivateFixedIncome.length"
    >
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsPrivateFixedIncome"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsPrivateFixedIncome"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
